import type { v4 } from '@sap/ux-specification-types';
import { syncRule, validity } from '../../../common/decoration/decorators';
import { getSettingsPathForPage, getSettingsPathForHeaderOP } from '../../application';
import type {
    ObjectPageHeaderAction,
    CustomHeaderActionOP,
    ObjectPageHeaderActionGroup,
    ObjectPageHeaderCustomActionMenu
} from './ObjectPageHeaderAction';

export class ObjectPageHeaderActions implements v4.ObjectPageHeaderActions {
    [key: string]:
        | ObjectPageHeaderAction
        | CustomHeaderActionOP
        | ObjectPageHeaderCustomActionMenu
        | ObjectPageHeaderActionGroup;
}

export class ObjectPageHeader implements v4.ObjectPageHeader {
    @syncRule({
        manifest: {
            path: (pageName: string[]): string => getSettingsPathForPage(pageName)
        }
    })
    @validity({
        since: '1.84.0'
    })
    editableHeaderContent?: boolean;

    @syncRule({
        manifest: {
            path: getSettingsPathForHeaderOP
        }
    })
    @validity({
        since: '1.84.0'
    })
    visible?: boolean;

    @syncRule({
        manifest: {
            path: getSettingsPathForHeaderOP
        }
    })
    @validity({
        since: '1.84.0'
    })
    anchorBarVisible?: boolean;
    sections?: v4.HeaderSections;
    actions?: ObjectPageHeaderActions;
}
